(function($) {
    $.widget("ca.caSelectionList", {
        options: {
          changeable: true,
          hideIcon: false
        },

        _create : function() {
            var selectedRow = $(this.element).find(':checked');

            selectedRow.parent().addClass('selected');

            if(this.options.hideIcon) {
                $(this.element).find('label').css('background-image', 'none');
            }

            this.setChangeable(this.options.changeable);
        },
        
        setChangeable: function(changeable) {
          this.options.changeable = changeable ? true : false;
          if(changeable) {
              this.element.find('label').off('click').click(function() {
                  $(this).parent().find('.selected').removeClass('selected').find('input').removeAttr('checked');
                  $(this).addClass('selected').find('input').attr('checked', 'checked');

                  return false;
              }).removeClass('disabled');
          } else {
              this.element.find('label').off('click').click(function() {
                  return false;
              }).addClass('disabled');
          }
        }
    });
})(jQuery);